import React, {useContext} from "react";
import {View} from "react-native";
import styles from './screen-styles';
import {styleVars} from "../app-style-vars";
import ScreenTemplate from "./ScreenTemplate";
import PtUserInfo from "../components/pt-customer-info/pt-customer-info";
import CreditLimit from "../components/pt-credit-limit/credit-limit";
import {getTranslation} from "../helpers/getTranslation";
import PtOrderHistoryPage from "../components/order-history/pt-order-history-page";
import PtDuePaymentsPage from "../components/due-payments/pt-due-payments-page";
import PtTicketsTrackingPage from "../components/tickets-tracking/pt-tickets-tracking-page";
import {isFeatureAvailable} from "../helpers/isFeatureAvailable";
import PtImpersonate from "../components/pt-impersonation/pt-impersonate";
import UserContext from "../helpers/UserContext";

/** set this to styles.withBoundaries to display borders around container views to visually debug layout overflows */
const showBoundaries = null;

/** actual page content should be put inside ScreenTemplate tag,
  * each component/section wrapped in a
  * <View style={[styles.pageContentSlotContainer, showBoundaries]}> tag
*/

export default function HomeScreen({navigation, route}:any) {

  const {userData, updateUserData} = useContext(UserContext);

  return (
    <ScreenTemplate navigation={navigation} route={route}>

      <View style={[styles.pageContentSlotContainer, showBoundaries]}>
        <View style={{backgroundColor: styleVars.boschBlue50}}>
          <PtUserInfo contentType={'light'} hideAddress hideEmail customerNameLabel={getTranslation('home.screen.welcome.label')}/>
        </View>
        {userData.canImpersonate ?
          <View>
            <PtImpersonate showModal={userData.mustImpersonate && userData.impersonatingId == null}/>
          </View>
          : null
        }
      </View>

      <View style={[styles.pageContentSlotContainer, showBoundaries]}>
        {isFeatureAvailable('orderHistory') ?
          <PtOrderHistoryPage
            pageSize={3}
            hideLoadMore={true}
            hideSearchAndFilters={true}
            limitedMode
          >
          </PtOrderHistoryPage>
          : null
        }
      </View>

      <View style={[styles.pageContentSlotContainer, showBoundaries]}>
        {isFeatureAvailable('duePayments') ?
          <PtDuePaymentsPage
            pageSize={3}
            hideLoadMore={true}
            hideSearchAndFilters={true}
            limitedMode
          >
          </PtDuePaymentsPage>
          : null
        }
      </View>

      <View style={[styles.pageContentSlotContainer, showBoundaries]}>
        {isFeatureAvailable('ticketsTracking') ?
          <PtTicketsTrackingPage
            pageSize={3}
            hideLoadMore={true}
            hideSearchAndFilters={true}
            limitedMode
          >
          </PtTicketsTrackingPage>
          : null
        }
      </View>


      <View style={[styles.pageContentSlotContainer, showBoundaries]}>
        {isFeatureAvailable('creditLimit') ?
          <View>
            <CreditLimit showTitle title={getTranslation('credit.limit.title')}/>
          </View>
          : null
        }
      </View>

    </ScreenTemplate>
  )
}
